import { createContext, useContext, useState, useEffect, useMemo } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SiteContext = createContext({});

export const useSite = () => useContext(SiteContext);

export const SiteProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [services, setServices] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [faq, setFaq] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const [sRes, svRes, tRes, fRes, gRes] = await Promise.all([
          axios.get(`${API}/settings`),
          axios.get(`${API}/services`),
          axios.get(`${API}/testimonials`),
          axios.get(`${API}/faq`),
          axios.get(`${API}/gallery`),
        ]);
        setSettings(sRes.data);
        setServices(svRes.data);
        setTestimonials(tRes.data);
        setFaq(fRes.data);
        setGallery(gRes.data);
      } catch (err) {
        if (process.env.NODE_ENV === 'development') {
          console.error("Failed to load site data", err);
        }
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []); // Empty deps is correct - we only want to load once on mount

  // Memoize context value to prevent unnecessary re-renders
  const value = useMemo(() => ({
    settings,
    services,
    testimonials,
    faq,
    gallery,
    loading,
    API
  }), [settings, services, testimonials, faq, gallery, loading]);

  return (
    <SiteContext.Provider value={value}>
      {children}
    </SiteContext.Provider>
  );
};
